import React from 'react';
import classnames from 'classnames';
import styles from "./heading.module.css";
const baseClass = 'heading';
export const Heading = React.forwardRef(({ className, id, tag: Component = 'h1', withShadow, children, variant }, ref) => {
    const classes = classnames(styles.heading, styles[`${baseClass}--${variant}`], { [styles[`${baseClass}--${variant}--with-shadow`]]: withShadow }, className);
    return (React.createElement(Component, { className: classes, id: id, "data-testid": "heading-component", ref: ref }, children));
});
Heading.displayName = 'Heading';
//# sourceMappingURL=index.js.map